const ES_EXCLUDED_COMPANY_IDS: string[] = ['cmpuvcr3mwmsw0c53o57wtxa8'];

export function filterAllCompanies<
  T extends {
    id: string;
    name: string;
    country?: string | null;
    defaultLanguage?: string | null;
  },
>(allCompanies: T[] | null | undefined, superAdminUserType: string | null | undefined): T[] {
  const isBarcontrol = superAdminUserType === 'BARCONTROL';
  const isSpainUser = superAdminUserType === 'SPAIN';

  if (isBarcontrol) {
    return (
      allCompanies?.filter((c) => (c.country || c.defaultLanguage)?.toUpperCase() === 'NO') ?? []
    );
  }

  if (isSpainUser) {
    return (
      allCompanies?.filter(
        (c) =>
          (c.country || c.defaultLanguage)?.toUpperCase() === 'ES' &&
          !ES_EXCLUDED_COMPANY_IDS.includes(c.id),
      ) ?? []
    );
  }

  return allCompanies ?? [];
}
